import { createFileRoute } from "@tanstack/react-router"
import { createLLMOMeta, createBreadcrumbSchema, createFAQSchema } from "@/lib/seo"
import { getUseCaseBySlug } from "@/data/use-cases/use-cases-registry"
import { getUseCaseBySlugForLanguage } from "@/data/use-cases/use-cases-i18n"
import { useTranslation } from "@/lib/i18n"
import UseCasePageLayout from "@/components/use-cases/UseCasePageLayout"

const data = getUseCaseBySlug("instagram-dm-email-collection")!

export const Route = createFileRoute("/use-case/instagram-dm-email-collection")({
  head: () => ({
    meta: [
      ...createLLMOMeta({
        title: data.seo.title,
        description: data.seo.description,
        url: "https://zapify.pro/use-case/instagram-dm-email-collection",
      }),
      { name: "keywords", content: data.seo.keywords },
    ],
    links: [{ rel: "canonical", href: "https://zapify.pro/use-case/instagram-dm-email-collection" }],
    scripts: [
      createBreadcrumbSchema({
        itemListElement: [
          { position: 1, name: "Home", item: "https://zapify.pro" },
          { position: 2, name: "Use Cases", item: "https://zapify.pro/use-case" },
          { position: 3, name: data.name, item: "https://zapify.pro/use-case/instagram-dm-email-collection" },
        ],
      }),
      createFAQSchema(data.faqs),
    ],
  }),
  component: CollectEmailsPage,
})

function CollectEmailsPage() {
  const { language } = useTranslation()
  const localizedData = getUseCaseBySlugForLanguage(language, "instagram-dm-email-collection") || data
  return <UseCasePageLayout data={localizedData} />
}
